import React from "react";
import { connect } from "react-redux";

const Translation = ({ lang, children }) => {
  return (<div key={lang}>
    {children}
  </div>);
};

const mSTP = (s: any) => ({
  lang: s.languageSelector.language,
});

export default connect(mSTP)(Translation);
